import { render, staticRenderFns } from "./Pointer.vue?vue&type=template&id=e70d16fa&scoped=true&"
import script from "./Pointer.vue?vue&type=script&lang=js&"
export * from "./Pointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70d16fa",
  null
  
)

export default component.exports